import { useMutation, useQueryClient } from "react-query";
import { useApiService } from "../useApiService";
import { ContactMessageControllerService } from "../../services";
import { QUERY } from "../../constants/query";

export const useSendContactMessage = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({
      name,
      email,
      phone,
      message,
    }: {
      name: string;
      email: string;
      phone?: string;
      message: string;
    }) =>
      handleRequest(
        ContactMessageControllerService.contactMessageControllerSendMessage({
          name,
          email,
          phone,
          message,
        })
      ),
    {
      onSuccess: (response) => {
        console.log("Message sent successfully:", response);
        queryClient.invalidateQueries(QUERY.CONTACT_MESSAGES);
      },
      onError: (error) => {
        console.error("Failed to send message:", error);
      },
    }
  );

  return {
    ...mutation,
  };
};
